import { ReactElement, useState } from 'react';
import { Button, Classes, Dialog } from '@blueprintjs/core';
import { UpdateArcOperator } from '..';
import { ArcOperator } from '@techshift/callie-private-api-typescript';

export type UpdateArcOperatorButtonProps = {
	operator: ArcOperator;
	onSuccess?: (operator: ArcOperator) => void;
};
export function UpdateArcOperatorButton(
	props: UpdateArcOperatorButtonProps
): ReactElement {
	const { operator, onSuccess } = props;

	const [isOpen, setIsOpen] = useState(false);

	return (
		<>
			<Button
				icon={'edit'}
				onClick={() => {
					setIsOpen(true);
				}}
			>
				Edit
			</Button>
			<Dialog isOpen={isOpen}>
				<div className={Classes.DIALOG_BODY}>
					<UpdateArcOperator
						operator={operator}
						onSuccess={(operator) => {
							onSuccess?.(operator);
							setIsOpen(false);
						}}
					/>
				</div>
				<div className={Classes.DIALOG_FOOTER}>
					<div className={Classes.DIALOG_FOOTER_ACTIONS}>
						<Button
							onClick={() => {
								setIsOpen(false);
							}}
						>
							Close
						</Button>
					</div>
				</div>
			</Dialog>
		</>
	);
}
